import React from 'react';
import { MapPin, Navigation, ExternalLink } from 'lucide-react';

const MapSection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden" id="hospital-map">
       <div className="section-container">
          <div className="grid lg:grid-cols-3 gap-12 items-center">
             {/* Text Content */}
             <div className="space-y-8">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/5 rounded-full border border-primary/10">
                   <MapPin size={14} className="text-primary" />
                   <span className="text-[10px] font-black tracking-[0.25em] uppercase text-primary">Main Campus Location</span>
                </div>
                <h2 className="text-navy font-display font-bold leading-[0.95] tracking-tight text-5xl md:text-6xl">
                   Locate Our <br /><em className="font-normal text-primary not-italic">Clinical Hub.</em>
                </h2>
                <div className="space-y-6">
                   <div className="p-6 rounded-3xl bg-secondary/30 border border-navy/5">
                      <h4 className="text-xs font-black uppercase tracking-widest text-navy/40 mb-3">Vanasthalipuram (Main)</h4>
                      <p className="text-navy font-bold leading-relaxed mb-4">Beside Line Of Vivekanandha Park, Hyderabad, Telangana 500070</p>
                      <div className="flex gap-4">
                         <a href="https://www.google.com/maps/search/?api=1&query=17.328539202391546,78.56571356246303" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-black tracking-widest text-[10px] uppercase group/map">
                            Open in Google Maps <ExternalLink size={14} className="group-hover/map:translate-x-0.5 transition-transform" />
                         </a>
                      </div>
                   </div>
                   <div className="flex items-center gap-4 p-8 rounded-[2.5rem] bg-navy text-white shadow-2xl shadow-navy/20">
                      <div className="w-12 h-12 rounded-2xl bg-primary/20 flex items-center justify-center text-primary">
                         <Navigation size={22} />
                      </div>
                      <p className="text-xs font-bold leading-relaxed">
                         Central Clinical Landmark <br />
                         <span className="text-white/40 font-normal">Near Vivekananda Park</span>
                      </p>
                   </div>
                </div>
             </div>

             {/* Map Embed */}
             <div className="lg:col-span-2 relative group">
                <div className="absolute inset-0 bg-primary/5 rounded-[4rem] blur-2xl -z-10 translate-x-4 translate-y-4" />
                <div className="rounded-[4rem] overflow-hidden border border-navy/10 shadow-glass-heavy h-[500px] relative">
                   <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30471.61217560834!2d78.544896!3d17.317888!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcba202af15ebdd%3A0x75ded4f3a8aab2e9!2sDr%20Suresh%20pet%20care%20hospital%20and%20surgical%20center!5e0!3m2!1sen!2sin!4v1775637884371!5m2!1sen!2sin" 
                      width="100%" 
                      height="100%" 
                      style={{ border: 0 }} 
                      allowFullScreen="" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Dr. Suresh Pet Care Location"
                      className="grayscale hover:grayscale-0 transition-all duration-1000 grayscale-ios"
                   ></iframe>
                </div>
             </div>
          </div>
       </div>
    </section>
  );
};

export default MapSection;
